import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { List } from 'react-virtualized';
import { compose } from 'react-apollo';
import { WrappedComponentProps, injectIntl } from 'react-intl';
import { InputText } from '@treelab/panda';

import { Modal } from '../';
import { Container, RecordItem, RecordText } from './styled';

import { IRootState, IDispatch } from '../../../modules/stores';

type IConnectProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
interface IProps extends IConnectProps, WrappedComponentProps {
  onClose: () => void;
}

const ModalRecordList: React.FC<IProps> = ({
  changeRecordById,
  onClose,
  recordIds,
  recordByIds,
  primaryColumnId,
  intl: { formatMessage },
}) => {
  const [search, setSearch] = useState('');
  const [recordList, setRecordList] = useState<{ id: string; name: string }[]>([]);

  useEffect(() => {
    setRecordList(
      recordIds.map((rId) => {
        const name = get(recordByIds, `${rId}.cells.${primaryColumnId}`, 'N/A') as string;
        return { id: rId, name };
      }),
    );
  }, [setRecordList, primaryColumnId, recordByIds, recordIds]);

  const filteredList = recordList.filter((rItem) => {
    if (search.length === 0) return true;
    if (!rItem.name) return false;
    if (String(rItem.name).toLowerCase().indexOf(search.toLowerCase()) === -1) return false;
    return true;
  });

  return (
    <Modal onClose={onClose} style={{ height: '280px', width: '400px' }}>
      <Container>
        <InputText
          css={{ height: '40px' }}
          input={{
            name: 'sesarch',
            onChange: (e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value),
            value: search,
          }}
          placeholder={formatMessage({ id: 'search.placeholder' })}
          meta={{}}
        />
        <List
          height={230}
          rowCount={filteredList.length}
          rowHeight={40}
          width={400}
          style={{ outline: 'none' }}
          rowRenderer={({ index, key, style }) => {
            const recItem = filteredList[index];

            return (
              <RecordItem
                key={key}
                style={style}
                onClick={() => {
                  changeRecordById(recItem.id);
                  onClose();
                }}
              >
                <RecordText>{recItem.name}</RecordText>
              </RecordItem>
            );
          }}
        />
      </Container>
    </Modal>
  );
};

const mapState = ({ core }: IRootState) => ({
  primaryColumnId: get(core, `viewById.${core.currentViewId}.fieldAllIds[0]`, '') as string,
  recordIds: get(core, `viewById.${core.currentViewId}.recordsAllIds`, []) as string[],
  recordByIds: core.recordById,
});

const mapDispatch = ({ core }: IDispatch) => ({
  changeRecordById: core.changeRecordById,
});

export default compose(
  injectIntl,
  connect(
    mapState,
    // @ts-ignore
    mapDispatch,
  ),
)(ModalRecordList);
